
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/[...all]",
      function () {
        return require("private-next-pages/destinations/[...all].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/[...all]"])
      });
    }
  